import CTNButton from '@ctn/ui/components/ctn-button';
import { useFormContext } from 'react-hook-form';

import IntervinientesListado from '@/components/IntervinientesListado';
import { useSolicitudContext } from '@/context/solicitud.context';

import { STEP_ID } from '@/constants/tramite.constants';
import {  flattenGroupSujetos } from '@/helpers/formSolicitudes';
import { type FormValues } from '@/interfaces/model/don.interface';


const ResumenStep2 = () => {
	const { watch } = useFormContext<Partial<FormValues>>();
	const { setActiveStep } = useSolicitudContext();

	const sujetosRequeridos = watch('sujetosRequeridos') ?? [];
	const sujetosAdicionales = watch('sujetosAdicionales') ?? [];

	return (
		<>
			{flattenGroupSujetos(sujetosRequeridos).length > 0 && (
				<section className="u-mt-80 u-mt-32@portrait">
					<header className="o-splitter">
						<h4 className="c-pnp-heading-h4">Intervinientes requeridos</h4>
						<CTNButton
							mode="secondary"
							label="Modificar"
							variant="ghost"
							size="size-40"
							onClick={() => setActiveStep(STEP_ID.SUJETOS)}
						/>
					</header>
					<div className="u-mt-24 u-mt-16@portrait">
						<IntervinientesListado data={flattenGroupSujetos(sujetosRequeridos)} />
					</div>
				</section>
			)}
			<section className="u-mt-80 u-mt-32@portrait">
				<header className="o-splitter">
					<h4 className="c-pnp-heading-h4">Intervinientes adicionales</h4>
					<CTNButton
						mode="secondary"
						label="Modificar"
						variant="ghost"
						size="size-40"
						onClick={() => setActiveStep(STEP_ID.SUJETOS)}
					/>
				</header>
				<div className="u-mt-24 u-mt-16@portrait">
					<IntervinientesListado
						data={sujetosAdicionales}
						noData="Aún no has añadido ningún interviniente adicional"
					/>
				</div>
			</section>
		</>
	);
};

export default ResumenStep2;
